export default function promiseMiddleWare() {
  return ({ dispatch, getState }) => (next) => (action) => {
    const { promise, types, ...rest } = action;

    if (!promise) {
      return next(action);
    }

    const [REQUEST, SUCCESS, FAILURE] = types;
    next({ ...rest, type: REQUEST });
    return promise().then(
      (data) => 
        // console.log(data);
         next({ ...rest, data, type: SUCCESS })
      
      ,
      (error) =>
      // debugger
        next({ ...rest, err: error, type: FAILURE })

    );
  };
}
